
import BusRatesTable from './BusRatesTable';
import './smallkey.css';
import { Helmet } from 'react-helmet';
import FAQSection from './FAQKeyword';
import Testimonialskeyword from './TestimonialKeyword';
function Busonhirepunetomahabaleshwar() {



    const cardData =
    {
        keyword: '  Bus on Hire on Pune to Mahabaleshwar Package Tour',
        heading: 'Samarth Travels:  Bus on Hire on Pune to Mahabaleshwar Package Tour',
        headingDescription: 'Samarth Travels offers bus on hire for Pune to Mahabaleshwar package tours, perfect for family trips, group outings, and corporate retreats. Choose from AC and non-AC buses ranging from 17 to 50 seaters, all maintained for comfort and safety. With professional drivers, fixed itinerary options, and transparent pricing, Samarth Travels ensures a smooth and enjoyable journey to Mahabaleshwar from Pune.',

        top: 'Top Places to Visit in Mahabaleshwar with Samarth Travels',

        "topPlaces": [
    {
      "title": "Arthur’s Seat",
      "description": "Known as the 'Queen of all Points', Arthur’s Seat offers panoramic views of the dense valleys of Brahma-Arayana and the Savitri River. Located at an elevation of 1,470 meters, this viewpoint is famous for its unique rock formations and the optical illusion where light objects thrown down the valley are said to come back due to air pressure. It's a must-visit for nature lovers and photography enthusiasts."
    },
    {
      "title": "Elephant’s Head Point",
      "description": "Resembling the head of an elephant, this rock formation offers breathtaking views of the Sahyadri mountain range. Also known as Needle's Point, it's an ideal spot for witnessing mesmerizing sunrises and sunsets amidst serene surroundings."
    },
    {
      "title": "Venna Lake",
      "description": "A man-made lake constructed in 1842 by Shri Appasaheb Maharaj, Venna Lake is a popular tourist attraction offering boating and horse riding activities. Surrounded by lush greenery, it's a perfect spot for family outings and enjoying local street food."
    },
    {
      "title": "Mahabaleshwar Temple",
      "description": "An ancient temple dedicated to Lord Shiva, Mahabaleshwar Temple is a significant pilgrimage site. Built in the 16th century, it houses a 6-foot-long 'Swayambhu' Shiva Linga and is considered one of the most sacred temples in the region."
    },
    {
      "title": "Mapro Garden",
      "description": "Famous for its strawberry produce, Mapro Garden is a delightful place featuring a chocolate factory, restaurant, and a retail outlet selling fruit-based products. Visitors can enjoy fresh strawberry treats and learn about the processing of various fruit products."
    },
    {
      "title": "Lingmala Waterfall",
      "description": "Situated on the Mahabaleshwar-Pune road, Lingmala Waterfall cascades from a height of 600 feet, offering a spectacular sight, especially during the monsoon season. The surrounding area is ideal for nature walks and picnics."
    },
    {
      "title": "Pratapgad Fort",
      "description": "Located 24 kilometers from Mahabaleshwar, Pratapgad Fort is a historical site where the famous battle between Chhatrapati Shivaji Maharaj and Afzal Khan took place in 1659. The fort offers panoramic views and insights into Maratha history."
    },
    {
      "title": "Wilson Point",
      "description": "As the highest point in Mahabaleshwar at 1,439 meters, Wilson Point is renowned for offering both sunrise and sunset views. The vast plateau with three watchtowers provides a 360-degree view of the surrounding landscape."
    },
    {
      "title": "Chinaman’s Falls",
      "description": "Once maintained by Chinese prisoners, Chinaman’s Falls is a captivating waterfall that plunges from a height amidst dense forests. It's a serene spot for nature lovers and photographers."
    },
    {
      "title": "Tapola (Mini Kashmir)",
      "description": "Known as the 'Mini Kashmir' of Maharashtra, Tapola is a small village near Mahabaleshwar famous for its picturesque Shivsagar Lake. Visitors can indulge in boating, kayaking, and enjoy the tranquil beauty of the region."
    }
  ],

"services": [
    {
        "name": "Rent a Bus for Pune to Mahabaleshwar Trip",
        "description": "Planning a trip from Pune to Mahabaleshwar? Rent a bus from Samarth Travels for a comfortable and scenic journey. Our buses are ideal for groups, offering a hassle-free and enjoyable ride to one of Maharashtra's most popular hill stations."
    },
    {
        "name": "Pune to Mahabaleshwar Bus Package on Rent",
        "description": "Samarth Travels offers customized Pune to Mahabaleshwar bus packages, designed to fit your travel preferences. Whether it’s a family vacation, corporate trip, or group tour, we offer tailored bus rental services to make your trip unforgettable."
    },
    {
        "name": "Hire a Bus for Mahabaleshwar Tour from Pune",
        "description": "Make your Mahabaleshwar tour from Pune more convenient and comfortable by hiring a bus from Samarth Travels. With a variety of buses to choose from, we ensure a smooth, safe, and enjoyable journey to the hill station."
    },
    {
        "name": "Affordable Bus Hire Pune to Mahabaleshwar",
        "description": "Looking for budget-friendly bus rental services for your trip from Pune to Mahabaleshwar? Samarth Travels offers affordable and reliable buses for group travel, ensuring a comfortable and economical ride without compromising on quality."
    },
    {
        "name": "32-Seater Bus for Pune to Mahabaleshwar",
        "description": "Samarth Travels offers a 32-seater bus rental for your journey from Pune to Mahabaleshwar. Perfect for medium-sized groups, our buses are spacious and comfortable, ensuring you have a pleasant travel experience throughout the journey."
    },
    {
        "name": "Luxury Bus Hire for Pune to Mahabaleshwar Tour",
        "description": "Indulge in luxury travel with Samarth Travels by renting a luxury bus for your Pune to Mahabaleshwar tour. Our luxury buses come equipped with plush seating, air-conditioning, and premium amenities, providing a superior travel experience for your group."
    },
    {
        "name": "Bus Rental for Family Tour Pune to Mahabaleshwar",
        "description": "Planning a family getaway to Mahabaleshwar? Rent a bus from Samarth Travels for a comfortable and affordable ride. Our buses are spacious, clean, and equipped with air-conditioning to ensure your family travels in comfort while exploring the scenic hill station."
    },
    {
        "name": "Bus Hire for Corporate Group Pune to Mahabaleshwar",
        "description": "Take your corporate group on a trip from Pune to Mahabaleshwar with Samarth Travels. Our buses are perfect for corporate tours, offering a comfortable and productive environment for team outings, seminars, or conferences, all while enjoying the scenic beauty of Mahabaleshwar."
    },
    {
        "name": "Rent a 45-Seater Bus for Pune to Mahabaleshwar",
        "description": "If you're traveling with a large group, rent a 45-seater bus from Samarth Travels for your Pune to Mahabaleshwar trip. With plenty of space, comfortable seating, and a well-maintained interior, this bus is perfect for large groups looking for a comfortable journey."
    },
    {
        "name": "Comfortable Bus Hire Pune to Mahabaleshwar",
        "description": "For a comfortable and stress-free journey to Mahabaleshwar, hire a bus from Samarth Travels. Our well-maintained buses offer ample space, air-conditioning, and a smooth ride, making your trip from Pune to Mahabaleshwar a memorable experience."
    }
],
"tableData": [
    ["Rent a Bus for Pune to Mahabaleshwar Trip", "Pune to Mahabaleshwar Bus Package on Rent"],
    ["Hire a Bus for Mahabaleshwar Tour from Pune", "Affordable Bus Hire Pune to Mahabaleshwar"],
    ["32-Seater Bus for Pune to Mahabaleshwar", "Luxury Bus Hire for Pune to Mahabaleshwar Tour"],
    ["Bus Rental for Family Tour Pune to Mahabaleshwar", "Bus Hire for Corporate Group Pune to Mahabaleshwar"],
    ["Rent a 45-Seater Bus for Pune to Mahabaleshwar", "Comfortable Bus Hire Pune to Mahabaleshwar"]
],


"whychoose": [
    {
        "WhyChooseheading": "Reliable Bus on Hire for Pune to Mahabaleshwar Package Tour",
        "WhyChoosedescription": "Samarth Travels offers reliable bus hire services for a seamless and comfortable journey from Pune to Mahabaleshwar. Our buses are perfect for group tours, family vacations, corporate trips, or any other group travel. With punctual pickups and smooth rides, we ensure your journey to Mahabaleshwar is both enjoyable and stress-free."
    },
    {
        "WhyChooseheading": "Comfortable and Spacious Buses for Long-Distance Travel",
        "WhyChoosedescription": "Our fleet of buses is ideal for long-distance trips like Pune to Mahabaleshwar. Whether you choose a minibus or a larger coach, our vehicles are equipped with comfortable seating, ample legroom, air-conditioning, and modern amenities to ensure your group travels in comfort and style throughout the journey."
    },
    {
        "WhyChooseheading": "Experienced Drivers for Safe and Timely Travel",
        "WhyChoosedescription": "Safety is our priority. Samarth Travels provides experienced, professional drivers who are well-acquainted with the Pune to Mahabaleshwar route. They ensure timely arrivals while prioritizing safety, comfort, and the best possible route to avoid traffic and ensure smooth travel on winding hill roads."
    },
    {
        "WhyChooseheading": "Affordable and Transparent Pricing for Pune to Mahabaleshwar Tours",
        "WhyChoosedescription": "We offer competitive, upfront pricing for bus hire services for your Pune to Mahabaleshwar package tour. With no hidden charges, you’ll know exactly what to expect in terms of cost, allowing you to plan your trip efficiently and with confidence. Our pricing structure is designed to provide the best value for your group’s travel needs."
    },
    {
        "WhyChooseheading": "Flexible 24/7 Availability for Your Pune to Mahabaleshwar Trip",
        "WhyChoosedescription": "Whether you need an early morning departure or a late evening return, Samarth Travels offers flexible 24/7 availability for your Pune to Mahabaleshwar tour. Our team is ready to accommodate your schedule, ensuring you can depart and return as per your convenience, making your travel plans hassle-free."
    },
    {
        "WhyChooseheading": "Easy Booking and Real-Time Updates for Your Tour",
        "WhyChoosedescription": "Booking your bus for the Pune to Mahabaleshwar package tour is easy with Samarth Travels. You can book online through our website or contact our customer service team directly. Once your booking is confirmed, you’ll receive real-time updates on your bus, including live tracking, driver contact details, and estimated arrival times to ensure a smooth and organized journey."
    },
    {
        "WhyChooseheading": "Clean, Sanitized, and Well-Maintained Buses for Your Comfort",
        "WhyChoosedescription": "We maintain the highest standards of cleanliness and hygiene for your group. All our buses are thoroughly sanitized before every trip, including the Pune to Mahabaleshwar tour. Our buses undergo regular maintenance to ensure they are in top condition, offering you a comfortable, safe, and enjoyable ride throughout your trip."
    },
    {
        "WhyChooseheading": "Multiple Payment Options for Hassle-Free Transactions",
        "WhyChoosedescription": "Samarth Travels offers a range of payment options, including cash, UPI, credit/debit cards, and digital wallets, making it easy and convenient for you to complete your booking. Choose the payment method that works best for you and enjoy a seamless booking experience for your Pune to Mahabaleshwar tour."
    }
]
















    }

const faqData = [
    {
        id: 1,
        question: 'How do I hire a bus for Pune to Mahabaleshwar package tour with Samarth Travels?',
        answer: 'Booking a bus for a Pune to Mahabaleshwar package tour with Samarth Travels is easy. You can book through our website or contact our customer support team. Share your travel details such as the number of passengers, travel dates, and preferred bus type, and we’ll provide the best package for your tour.',
    },
    {
        id: 2,
        question: 'What types of buses are available for the Pune to Mahabaleshwar tour?',
        answer: 'We offer a variety of buses for the Pune to Mahabaleshwar tour, including 22-seater, 32-seater, 40-seater, and 50-seater buses. You can choose between AC or Non-AC buses depending on your group’s needs and comfort level.',
    },
    {
        id: 3,
        question: 'Are the buses comfortable for long-distance travel to Mahabaleshwar?',
        answer: 'Yes, our buses are well-maintained and perfect for long-distance travel. With comfortable seating, air-conditioning, ample luggage space, and clean interiors, your journey to Mahabaleshwar will be enjoyable and relaxing.',
    },
    {
        id: 4,
        question: 'Can I book the bus for a one-day Pune to Mahabaleshwar trip?',
        answer: 'Yes, we offer one-day bus rental packages for Pune to Mahabaleshwar trips. Whether you are planning a day trip or an extended stay, we will customize the package according to your requirements.',
    },
    {
        id: 5,
        question: 'What is included in the Pune to Mahabaleshwar bus package?',
        answer: 'Our bus rental package for Pune to Mahabaleshwar includes the vehicle, driver, fuel, and basic amenities. Additional costs like tolls, parking, and permits will be shared with you in advance for complete transparency.',
    },
    {
        id: 6,
        question: 'Can I customize the pickup and drop-off locations for the Mahabaleshwar tour?',
        answer: 'Yes, we offer customized pickup and drop-off locations. Whether you want to depart from a specific area in Pune or make multiple stops, we’ll plan the best route for your convenience.',
    },
    {
        id: 7,
        question: 'Do you offer 24/7 support for Pune to Mahabaleshwar bus rentals?',
        answer: 'Yes, our team is available 24/7 to assist you with any queries or changes to your booking. We ensure a hassle-free experience from start to finish, and we’re always ready to provide support when needed.',
    },
];

const testimonials = [
    {
        name: 'Mr. Kiran Deshmukh',
        role: 'Group Tour Organizer',
        text: 'We booked a 40-seater AC bus for a group trip from Pune to Mahabaleshwar. The bus was very comfortable, and the journey was smooth. Our group had a fantastic time, and we appreciate the excellent service from Samarth Travels.',
        image: '/img/testimonial/testi_2_40.jpg',
    },
    {
        name: 'Mrs. Meera Shah',
        role: 'Family Trip Planner',
        text: 'Our family rented a 32-seater Non-AC bus for a trip to Mahabaleshwar. The driver was courteous, the bus was clean, and we enjoyed the scenic drive. It was a great experience, and we’ll definitely consider Samarth Travels for our future trips.',
        image: '/img/testimonial/testi_2_41.jpg',
    },
];
























    const contactData = {
        heading: `${cardData.keyword} Contact Number`,
        contactNumbers: [
            "+91 9860256019",
            "+91 9527500025",

        ],
        email: "samarthtravels9119@gmail.com"
    };


   const Images = [
        {
            place: "/images/keyword/1.jpg",
            text: " Tempo Traveller Pune",
        },
        {
            place: "/images/keyword/2.jpg",
            text: " Tempo Traveller on Rent Pune",
        },
        {
            place: "/images/keyword/3.jpg",
            text: " Bus on Rent in Pune",
        },
        {
            place: "/images/keyword/4.jpg",
            text: " Tempo Traveller on Rent",
        },
        {
            place: "/images/keyword/5.jpg",
            text: " Tempo Traveller Rent in Pune",
        },
        {
            place: "/images/keyword/6.jpg",
            text: " Tempo Traveller Hire in Pune",
        },
        {
            place: "/images/keyword/7.jpg",
            text: " Mini Bus for Rent",
        },

        {
            place: "/images/keyword/8.jpg",
            text: " Bus on Rent Hire",
        },

        {
            place: "/images/keyword/9.jpg",
            text: " Bus on Rent Pune",
        },
        {
            place: "/images/keyword/10.jpg",
            text: " Bus Rental in Pune",
        },

        {
            place: "/images/keyword/11.jpg",
            text: " Hire Tempo Traveller",
        },
        {
            place: "/images/keyword/12.jpg",
            text: " Bus Hire in Pune",
        },
        {
            place: "/images/keyword/13.jpg",
            text: " Ac Tempo Traveller Rent Pune",
        },
        {
            place: "/images/keyword/14.jpg",
            text: " Bus Hire For Outstation",
        },
        {
            place: "/images/keyword/15.jpg",
            text: " Bus on Rent for Local",
        },
        {
            place: "/images/keyword/16.jpg",
            text: " Bus Rental For Wedding",
        },
        {
            place: "/images/keyword/17.jpg",
            text: "Bus Rent for Marriage",
        },
        {
            place: "/images/keyword/18.jpg",
            text: " Bus Rental For Corporate Events",
        },
        {
            place: "/images/keyword/19.jpg",
            text: "  Bus Rental for Tour",
        },

        {
            place: "/images/keyword/20.jpg",
            text: "Bus Rental For Corporate in Pune",
        },
        {
            place: "/images/keyword/21.jpg",
            text: " Tempo Traveller on Rent in Pune",
        },
        {
            place: "/images/keyword/22.jpg",
            text: " AC Bus On Rent",
        },
        {
            place: "/images/keyword/23.jpg",
            text: " Non Ac Bus Rental Service",
        },
        {
            place: "/images/keyword/24.jpg",
            text: "Bus on Hire on Pune to Mahabaleshwar Package Tour ",
        },
        {
            place: "/images/keyword/25.jpg",
            text: "Bus Hire for Picnic",
        },
    ];


    const images = [
        { src: "/images/fleets/1.jpg", alt: "Image 1" },
        { src: "/images/fleets/2.jpg", alt: "Image 1" },
        { src: "/images/fleets/3.jpg", alt: "Image 1" },
        { src: "/images/fleets/4.jpg", alt: "Image 1" },
        { src: "/images/fleets/5.jpg", alt: "Image 1" },
        { src: "/images/fleets/6.jpg", alt: "Image 1" },
        { src: "/images/fleets/7.jpg", alt: "Image 1" },
        { src: "/images/fleets/8.jpg", alt: "Image 1" },
        { src: "/images/fleets/9.jpg", alt: "Image 1" },


    ];




const productSchema = {
  "@context": "https://schema.org",
  "@type": "Product",
  "name": "Bus on Hire for Pune to Mahabaleshwar Package Tour",
  "image": "https://samarthtravels.com/assets/images/pune-to-mahabaleshwar-bus-tour.jpg",
  "description": "Rent a bus for a comfortable and affordable Pune to Mahabaleshwar package tour. Options include 32-seater and 45-seater buses, both luxury and budget-friendly, for family trips, corporate groups, and more.",
  "brand": {
    "@type": "Brand",
    "name": "Samarth Travels"
  },
  "aggregateRating": {
    "@type": "AggregateRating",
    "bestRating": "5",
    "worstRating": "1",
    "ratingValue": "4.8",
    "ratingCount": "5471"
  },
  "offers": {
    "@type": "Offer",
    "priceCurrency": "INR",
    "price": "6000",
    "availability": "https://schema.org/InStock",
    "url": "https://samarthtravels.com/bus-on-hire-for-pune-to-mahabaleshwar-tour"
  }
};




    return (
        <div>
<Helmet>
  <title>Bus on Hire for Pune to Mahabaleshwar Tour | Affordable & Comfortable | Samarth Travels</title>
  <meta 
    name="description" 
    content="Hire a bus for a Pune to Mahabaleshwar tour, with options for luxury 32-seater and 45-seater buses. Ideal for family trips, corporate groups, and sightseeing, offering a comfortable journey to Mahabaleshwar." 
  />
  <meta 
    name="keywords" 
    content="Rent a Bus for Pune to Mahabaleshwar Trip, Pune to Mahabaleshwar Bus Package on Rent, Hire a Bus for Mahabaleshwar Tour from Pune, Affordable Bus Hire Pune to Mahabaleshwar, 32-Seater Bus for Pune to Mahabaleshwar, Luxury Bus Hire for Pune to Mahabaleshwar Tour, Bus Rental for Family Tour Pune to Mahabaleshwar, Bus Hire for Corporate Group Pune to Mahabaleshwar, Rent a 45-Seater Bus for Pune to Mahabaleshwar, Comfortable Bus Hire Pune to Mahabaleshwar" 
  />
  <script type="application/ld+json">
    {JSON.stringify(productSchema)}
  </script>
</Helmet>




            <div className="breadcumb-wrapper" data-bg-src="/images/breadcumb-bg.jpg">
                <div className="container">
                    <div className="breadcumb-content">
                        <h1 className="breadcumb-title text-center">{cardData.keyword}</h1>
                    </div>
                </div>
            </div>



            <section>
                <div className="container-fluid" >
                    <div className="row container-fluid">
                        <div className="col-12 col-md-7 bg-foootr">
                            <img src='/images/keyword/24.jpg' alt='img' />
                            <h3 className="py-1"
                                style={{
                                    color: '#322E77', // Red color for the title 
                                    textShadow: '5px 5px 10px rgba(255, 255, 255, 0.7)', // Light shadow effect
                                    fontWeight: 'bold'
                                }}


                            >{cardData.heading} </h3><p className='fw-bold '>{cardData.headingDescription}</p>
                            <div className="">
                                <p className='fw-bold py-3 darkcolorrr'>{cardData.top}</p>
                                {cardData.topPlaces.map((place, index) => (
                                    <div key={index} className="">
                                        <div
                                            style={{
                                                cursor: 'pointer',
                                                padding: '10px',
                                                marginBottom: '7px',
                                                borderRadius: '8px',
                                                transition: 'transform 0.2s'
                                            }}

                                        >
                                            <h4 className="mb-1 darkcolorrr">{place.title}</h4>
                                            <p className="mb-0">{place.description}</p>
                                        </div>
                                    </div>
                                ))}
                            </div>
                            <div
                                style={{
                                    cursor: 'pointer',
                                    padding: '10px',
                                    marginBottom: '7px',
                                    borderRadius: '8px', // Optional: rounded corners
                                    transition: 'transform 0.2s' // Optional: smooth scaling effect
                                }}
                            >
                                {cardData.services.map((service, index) => (
                                    <div key={index} className=" my-4">
                                        <h4 className="py-1 darkcolorrr">{service.name}</h4>
                                        <p>{service.description}</p>
                                    </div>
                                ))}
                            </div>

                            <table className="table table-responsive Border-key my-2">
                                <tbody className=' Border-key'>
                                    {cardData.tableData.map((row, rowIndex) => (
                                        <tr className='Border-key ' key={rowIndex}>
                                            {row.map((cell, cellIndex) => (
                                                <td key={cellIndex} className=' Border-key bluecolor fw-bold' >{cell}</td>
                                            ))}
                                        </tr>
                                    ))}
                                </tbody>
                            </table>
                            <h3 className='pt-md-3'>{cardData.keyword + " Rates"}</h3>
                            <BusRatesTable />

                            <div id="why-choose-section"
                                className='px-2 bg-foootr'>
                                {cardData.whychoose.map((item, index) => (
                                    <div key={index}>
                                        <h4 className="py-1 whycolor">{item.WhyChooseheading}</h4>
                                        <p>{item.WhyChoosedescription}</p>
                                    </div>
                                ))}
                            </div>


                            <div className="row twm-faq-section-1 m-b30">


                                <div className=" col-md-12 wow fadeInDown" data-wow-delay="0.2">
                                    <div className="twm-faq-info-wrap">

                                        <div className="section-head left">
                                            <h2 className="twm-large-title site-text-dark">FAQS {cardData.keyword} For Samarth Travels </h2>
                                        </div>


                                        <div className="twm-faq-info">
                                            <div className="accordion twm-acdn" id="sf-faq-accordion">


                                                <FAQSection faqs={faqData} accordionId="drivingAccordion" />

                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>


                            <Testimonialskeyword
                                data={testimonials}
                                title="What Our Clients Are Saying"
                                subtitle="Customer Feedback"
                            />


                            <div className='py-4'>

                                <div className="contact-box Borderr">
                                    <h3>{contactData.heading}</h3>
                                    <p className='text-black'>For booking inquiries or any assistance, please feel free to contact us:</p>
                                    <div className="contact-details">
                                        <p><strong className='darkcolor'>Mobile No:</strong></p>
                                        <ul>
                                            {contactData.contactNumbers.map((number, index) => (
                                                <li key={index}>
                                                    <a href={`tel:${number}`} className="contact-link fw-bold fs-5">
                                                        {number}
                                                    </a>
                                                </li>
                                            ))}
                                        </ul>
                                        <p><strong className='darkcolor'>Email Id: </strong>
                                            <a href={`mailto:${contactData.email}`} className="contact-link">
                                                {contactData.email}
                                            </a>
                                        </p>
                                    </div>
                                </div>
                            </div>
                        </div>

                        <div className='col-12 col-md-4' >
                            {Images.map((e) => {
                                return (
                                    <div className="box1">
                                        <a
                                            href="./"
                                            className="d-flex justify-content-around align-items-center"
                                        >
                                            <div className="b1">
                                                <img src={e.place} alt="img" />
                                            </div>
                                            <div className="b2">
                                                {" "}
                                                <a href="./" className='px-3'>{e.text}</a>
                                            </div>
                                        </a>
                                    </div>
                                );
                            })}


                            <div className="gallery-container">
                                <h2 className="gallery-title">Our Fleets</h2>
                                <div className="gallery-row d-flex flex-wrap">
                                    {images.map((image, index) => (
                                        <div className="gallery-item col-md-4" key={index}>
                                            <img
                                                src={image.src}
                                                alt={image.alt}
                                                className="gallery-image"

                                            />
                                        </div>
                                    ))}

                                </div>
                            </div>

                            <div className=" rounded p-4 shadow-sm Uni_border "
                                style={{
                                    cursor: 'pointer',
                                    padding: '10px',
                                    border: '3px dotted #FF8F1F',
                                    marginBottom: '7px',
                                    fontWeight: 'bold',
                                }}

                            >
                                <h4 className="pb-3 pt-3 lead fw-bold text-dark">Contact Information</h4>

                                <div className="row">

                                    <div className="col-12 mb-3">
                                        <div className="Small_border  rounded text-center py-2 " style={{ backgroundColor: '#FF8F1F' }}>
                                            <h4 className=" lead fw-semibold whitt textt-dark">Phone Numbers</h4>
                                            <i className="bi bi-telephone-fill fs-1 mb-2"></i>
                                            <div className=''>
                                                <a href="tel:+919860256019" className="d-block  text-white">+91 9860256019</a>
                                                <a href="tel:+919527500025" className="d-block  text-white">+91 9527500025</a>


                                            </div>
                                        </div>
                                    </div>


                                    <div className="col-12 mb-3 ">
                                        <div className="Small_border rounded text-center">
                                            <i className="bi bi-envelope fs-1 mb-2"></i>
                                            <div className='rounded py-2' style={{ backgroundColor: '#FF8F1F' }}>
                                                <h4 className=" fw-semibold lead whitt textt-dark">Email</h4>
                                                <a href="mailto:samarthtravels9119@gmail.com" className=" text-white d-block">
                                                    samarthtravels9119@gmail.com
                                                </a>
                                            </div>
                                        </div>
                                    </div>


                                    <div className="col-12 mb-3 ">
                                        <div className="Small_border  rounded text-center">
                                            <i className="bi bi-house-fill fs-1 mb-2"></i>
                                            <div className='rounded py-2' style={{ backgroundColor: '#FF8F1F' }}>
                                                <h4 className=" fw-semibold lead whitt textt-dark">Address</h4>
                                                <p className="whit text-white ">
                                                    <i> Samarth Travels <br />
                                                        Flat no 201, Juhi Building, Suyash Shrushti Society, Tukai darshan Hadapsar, Pune- 411028
                                                    </i>
                                                </p>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>


                        </div>
                    </div>
                </div>
            </section>


        </div>
    );
}

export default Busonhirepunetomahabaleshwar;